import { env } from '@/plugins/env';

const TOKEN_LOCALSTORAGE_KEY = 'TOKEN';
const SESSION_COOKIE_NAME = '__Secure-SID';

export const getToken = () => {
  const token = document?.cookie?.split('; ')?.find(s => s.startsWith(SESSION_COOKIE_NAME))?.split('=')?.pop();
  if (token) {
    setToken(token);
    return token;
  } else {
    setToken(null);
    return null;
  }
};

export const setToken = (token) => window.localStorage.setItem(TOKEN_LOCALSTORAGE_KEY, token);

/**
 * Expira o cookie de sessão `__Secure-SID` no client e limpa o espelho no localStorage.
 *
 * Após um purge de sessões no accounts o cookie continua no browser (só some por expiração
 * natural) e mantém o guard revalidando em loop de 401. O cookie não é HttpOnly, então dá
 * pra expirá-lo aqui. Para o browser apagar, o write precisa casar os atributos com que o
 * accounts setou (`Domain=<VUE_APP_DOMAIN>; Path=/; Secure; SameSite=None`) e, por ser um
 * cookie com prefixo `__Secure-`, incluir `Secure`. Cobrimos a variação com Domain
 * (compartilhado entre os subdomínios do ambiente) e a host-only por segurança.
 */
export const clearToken = () => {
  if (typeof document !== 'undefined') {
    const attrs = 'Path=/; Max-Age=0; Secure; SameSite=None';
    document.cookie = `${SESSION_COOKIE_NAME}=; ${attrs}`;

    const domain = env?.VUE_APP_DOMAIN;
    if (domain) {
      document.cookie = `${SESSION_COOKIE_NAME}=; Domain=${domain}; ${attrs}`;
      document.cookie = `${SESSION_COOKIE_NAME}=; Domain=.${domain}; ${attrs}`;
    }
  }

  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(TOKEN_LOCALSTORAGE_KEY);
  }
};
